import { motion } from "framer-motion";
import { X, Check, ArrowDown } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { BEFORE_AFTER } from "@/data/content";

export default function Transformation() {
  return (
    <section className="py-24 sm:py-32 bg-cardbg" data-testid="transformation-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Client Transformation"
          title="Transformation Is More Than a Number on the Scale."
          sub="Real transformation shows up in how you think, feel and live — not just what you weigh."
        />
        <div className="grid md:grid-cols-[1fr_auto_1fr] gap-8 items-stretch">
          <Reveal>
            <div
              className="h-full bg-ivory border border-peach/30 rounded-3xl p-8 sm:p-10"
              data-testid="transformation-before"
            >
              <p className="text-xs uppercase tracking-[0.25em] font-bold text-peach mb-6">Before</p>
              <ul className="space-y-4">
                {BEFORE_AFTER.before.map((b, i) => (
                  <motion.li
                    key={b}
                    initial={{ opacity: 0, x: -16 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.07 }}
                    className="flex items-center gap-3 text-inkmuted"
                  >
                    <span className="w-7 h-7 rounded-full bg-peach/15 flex items-center justify-center shrink-0">
                      <X size={14} className="text-peach" />
                    </span>
                    <span className="font-serif italic text-xl">{b}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </Reveal>
          <div className="flex items-center justify-center" aria-hidden="true">
            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ repeat: Infinity, duration: 2.4, ease: "easeInOut" }}
              className="w-12 h-12 rounded-full bg-forest flex items-center justify-center rotate-90 md:rotate-0"
            >
              <ArrowDown size={20} className="text-gold -rotate-90 md:rotate-90" />
            </motion.div>
          </div>
          <Reveal delay={0.15}>
            <div
              className="h-full bg-forest rounded-3xl p-8 sm:p-10 shadow-hover"
              data-testid="transformation-after"
            >
              <p className="text-xs uppercase tracking-[0.25em] font-bold text-gold mb-6">After</p>
              <ul className="space-y-4">
                {BEFORE_AFTER.after.map((a, i) => (
                  <motion.li
                    key={a}
                    initial={{ opacity: 0, x: 16 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.07 }}
                    className="flex items-center gap-3 text-ivory"
                  >
                    <span className="w-7 h-7 rounded-full bg-moss/20 flex items-center justify-center shrink-0">
                      <Check size={14} className="text-moss" />
                    </span>
                    <span className="font-serif italic text-xl">{a}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
